export default __webpack_public_path__ + "static/media/clock_inactive.f175b26c.png";